<div #dialog>
  @if (this.form) {
    <form [formGroup]="this.form" (ngSubmit)="this.submit()">
      <nb-card>
        <nb-card-header>
          <div>
            <h1>{{ 'filter' | translate:{value:(this.title | translate)} }}</h1>
            @if (this.subtitle) {
              <h2>{{ this.subtitle }}</h2>
            }
          </div>
        </nb-card-header>
        <nb-card-body>
          <table class="edit-table">
            <thead>
            </thead>
            <tbody>
              @for (col of description; track col) {
                <tr>
                  <td><label>{{ col.title | translate }}</label></td>
                  <td class="filter-item">
                    @if (col.type === ColType.DATE) {
                      <div>
                        <div>
                          <label>{{ 'afterdate' | translate }}</label>
                          <input nbInput [placeholder]="'enterdate' | translate" [nbDatepicker]="datepicker_start" [formControlName]="col.name + '_start'" [ngStyle]="col.style">
                          <nb-datepicker #datepicker_start></nb-datepicker>
                        </div>
                        <div>
                          <label>{{ 'beforedate' | translate }}</label>
                          <input nbInput [placeholder]="'enterdate' | translate" [nbDatepicker]="datepicker_end" [formControlName]="col.name + '_end'" [ngStyle]="col.style">
                          <nb-datepicker #datepicker_end></nb-datepicker>
                        </div>
                      </div>
                    }
                    @if (col.type === ColType.LOCATION) {
                      <div>
                        <bst-map-editor [formControlName]="col.name" [ngStyle]="col.style"></bst-map-editor>
                      </div>
                    }
                    @if (col.type === ColType.LISTADDER) {
                      <div>
                        <bst-list-adder [target]="filtername(col)" [formControlName]="col.name" [autolist]="true" [ngStyle]="col.style"></bst-list-adder>
                      </div>
                    }
                    @if (col.type === ColType.PHONE) {
                      <div>
                        <input type="number" nbInput maxlength="20" [placeholder]="'enternumber' | translate" [formControlName]="col.name" [ngStyle]="col.style">
                        <!--                <ngx-intl-tel-input [cssClass]="'status-basic shape-rectangle'"-->
                        <!--                                    [enableAutoCountrySelect]="true"-->
                        <!--                                    [enablePlaceholder]="true"-->
                        <!--                                    [searchCountryFlag]="true"-->
                        <!--                                    [selectFirstCountry]="false"-->
                        <!--                                    [phoneValidation]="true"-->
                        <!--                                    [formControlName]="col.name"-->
                      <!--                ></ngx-intl-tel-input>-->
                    </div>
                  }
                  @if (col.type === ColType.AREA) {
                    <div>
                      <textarea nbInput [maxLength]="10000" [placeholder]="'enteritem' | translate:{value: (col.subtitle ? col.subtitle : col.title) | translate}" [formControlName]="col.name" [ngStyle]="col.style"></textarea>
                    </div>
                  }
                  @if (col.type === ColType.STRING) {
                    <div>
                      <input type="text" nbInput [maxLength]="col.length || 100" [placeholder]="'enteritem' | translate:{value: (col.subtitle ? col.subtitle : col.title) | translate}" [formControlName]="col.name" [ngStyle]="col.style">
                    </div>
                  }
                  @if (col.type === ColType.INT) {
                    <div>
                      <bst-dual-slider [currency]="false" [range]="col.range || {gte: 0, lte: col.length}" [formControlName]="col.name" [ngStyle]="col.style"></bst-dual-slider>
                    </div>
                  }
                  @if (col.type === ColType.BOOL) {
                    <nb-select [formControlName]="col.name" [placeholder]="'any' | translate" [ngStyle]="col.style">
                      <nb-option [value]="null">{{ 'any' | translate }}</nb-option>
                      <nb-option [value]="true">{{ 'yes' | translate }}</nb-option>
                      <nb-option [value]="false">{{ 'nee' | translate }}</nb-option>
                    </nb-select>
                  }
                  @if (col.type === ColType.CURRENCY) {
                    <div>
                      <bst-dual-slider [currency]="true" [range]="col.range || {gte: 0, lte: col.length}" [formControlName]="col.name" [ngStyle]="col.style"></bst-dual-slider>
                    </div>
                  }
                  @if (col.type === ColType.RANGE) {
                    <div>
                      <input nbInput class="input-full-width" [placeholder]="'enterdaterange' | translate" [nbDatepicker]="rangepicker" [formControlName]="col.name" [ngStyle]="col.style">
                      <nb-rangepicker #rangepicker></nb-rangepicker>
                    </div>
                  }
                  @if (col.type === ColType.RADIO) {
                    <div>
                      <nb-radio-group [name]="col.name" [formControlName]="col.name" [ngStyle]="col.style">
                        @for (r of col.list; track r) {
                          <nb-radio [value]="r.id">{{ r.name }}</nb-radio>
                        }
                      </nb-radio-group>
                    </div>
                  }
                  @if (col.type === ColType.SELECT) {
                    <div>
                      <nb-select [formControlName]="col.name"
                        [multiple]="col.multiple"
                        [placeholder]="'enteritem' | translate:{value: (col.title | translate)}"
                        [ngStyle]="col.style">
                        @for (r of col.list; track r) {
                          <nb-option [value]="r.id">{{ r.name }}</nb-option>
                        }
                      </nb-select>
                    </div>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </nb-card-body>
      <nb-card-footer>
        <!--        <button nbButton type="button" (click)="this.cancel()">{{ 'cancel' | translate }}</button>-->
        <button nbButton type="button" (click)="this.clear()">{{ 'clear' | translate }}</button>
        <button nbButton status="primary" [disabled]="this.form.invalid">{{ 'apply' | translate }}</button>
      </nb-card-footer>
    </nb-card>
  </form>
}
</div>
